import {makeLogger} from '../../../../logger/logger';
import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import {QueryPrecachingStrategyService} from '../../QueryPrecachingStrategyService';
import type {PrechachingData} from '../../types/precaching-data.type';
import {STRATEGY_SERVICE} from '../../utils/variables';

const {err} = makeLogger({
  pathToCurrentFile: 'components/strategies/services/precaching-service/precaching-fallback.service.ts'
});

@Service({id: 'precacheFallback' + STRATEGY_SERVICE})
export class PrecachingFallbackStrategyServiceBuilder extends StrategyBuilder<QueryPrecachingStrategyService> {

  build(details: PrechachingData): QueryPrecachingStrategyService {
      return new PrecachingFallbackStrategy(details);
  }
}

export class PrecachingFallbackStrategy extends QueryPrecachingStrategyService {
  details: PrechachingData;

  constructor(details: PrechachingData) {
      super();
      this.details = details;
  }

  async setup(){}

  hasInCache(cacheKey: string): boolean {
      return false;
  }
  getFromCache(cacheKey: string) {
      err('PrecachingFallbackStrategy getFromCache called, but cache is Fallback, returning undefined.');
      return undefined;
  }
  async getFromCacheWithCallback<T>(cacheKey: string, callback: () => Promise<T>) {
      return await callback();
  }

}
